import Cookies from '../../common/Cookies';
import Options from '../../child/helpers/options/defaults';
import IPC from './ipc';
import { COOKIES } from '../../child/components/layers/widget/types';

const CookiesManager = {
    onStartChat: () => {
        var expires = new Date();
        expires.setTime(expires.getTime() + 60 * 60 * 1000);
        Cookies.setItem(Options.cookies.WIDGET_START_CHAT_COOKIE, true, expires);
    },

    onStopChat: () => {
        Cookies.removeItem(Options.cookies.WIDGET_START_CHAT_COOKIE);
    },

    onStartQuestionnaire: () => {
        var expires = new Date();
        expires.setTime(expires.getTime() + 24 * 60 * 60 * 1000);
        Cookies.setItem(Options.cookies.WIDGET_START_QUESTIONNAIRE_COOKIE, true, expires);
    },

    checkUsabilaCookie: () => {
        const usabliaCookie = Cookies.getItem(Options.cookies.USABILA_COOKIE);
        if (usabliaCookie && usabliaCookie === '1') {
            IPC.sendEvent(COOKIES.CHECK_USABILA, {
                isPresent: true
            });
        } else {
            IPC.sendEvent(COOKIES.CHECK_USABILA, {
                isPresent: false
            });
        }
    },

    setDisablingProactiveCookie: () => {
        Cookies.setItem(Options.cookies.WIDGET_PROACTIVE, 'NO');
    },

    checkDisablingProactiveCookie: () => {
        const proactiveCookie = Cookies.getItem(Options.cookies.WIDGET_PROACTIVE);
        return proactiveCookie && proactiveCookie === 'NO';
    }
};

export default CookiesManager;
